'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCISImpression = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toCISImpression = exports.toCISImpression = function toCISImpression(job) {
  return {
    matches: (0, _uniq2.default)((0, _map2.default)((0, _get2.default)(job, 'contactMatches', []), function (t) {
      return t.type;
    })).sort()
  };
};